import { put, call, take, fork } from 'redux-saga/effects'
import { CourseCreationSuggestPageOutlineService } from '../../api/course-creation'
import { aICreatorSuggestPageOutlineSuccess } from '../../reducers/ai-creator/action'
import { SUGGEST_PAGE_OUTLINE } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 * Flow for suggesting page outline goals
 * @param {Object} payload - The payload containing requestData and callback
 */
function* suggestPageOutlineFlow(payload) {
  try {
    const { requestData, callback } = payload

    const response = yield call(
      CourseCreationSuggestPageOutlineService,
      requestData,
    )

    yield put(aICreatorSuggestPageOutlineSuccess(response))
    yield put(operationSuccess())

    if (callback) {
      callback(response)
    }
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 * Watcher for suggest page outline actions
 */
export default function* aICreatorSuggestPageOutlineWatcher() {
  while (true) {
    const action = yield take(SUGGEST_PAGE_OUTLINE)
    const { payload } = action

    yield fork(generalSaga, suggestPageOutlineFlow, payload, false)
  }
}
